module.exports = __webpack_public_path__ + "static/img/11.4a7dccd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/zh/11.png
// module id = iDZh
// module chunks = 0